import loadingReducer from './loadingReducer'
import commonReducer from './commonReducer'

const rootReducer = {
  loadingStore: loadingReducer,
  commonStore: commonReducer
}
export default rootReducer
